import React from "react";
import { LoginButton } from "../../components/Buttons";

const LoginScreen = () => {
  return <LoginButton/>
};

export default LoginScreen;